import { render } from "./standardPage.vue?vue&type=template&id=16fe2a80&scoped=true&ts=true"
import script from "./standardPage.vue?vue&type=script&lang=ts"
export * from "./standardPage.vue?vue&type=script&lang=ts"

import "./standardPage.vue?vue&type=style&index=0&id=16fe2a80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16fe2a80"]])

export default __exports__